import { MyInfoKey } from "./key";
import { useBaseQuery } from "../baseQuery";
import { GetUserResponseByToken } from "@maven-rest/sso/User.dto";
import { UserUrl } from "@maven-rest/sso/User.url";

export function useMyInfoQuery() {
  return useBaseQuery<GetUserResponseByToken>({
    queryKey: [MyInfoKey.MyInfo],
    fnOption: { host: process.env.REACT_APP_SSO_BE_URL, url: UserUrl.getMyInfo },
    cacheTime: 5 * 60 * 1000,
  });
}
